<template>
    <div class="container mx-auto px-3 pb-32 md:px-8 font-sans max-w-(--breakpoint-xl)">
        <h1 class="sr-only">Dashboard</h1>

        <div class="grid grid-cols-12 gap-x-6 gap-y-2 md:gap-y-8">
            <div class="col-span-12">
                <home-group-terms-banner></home-group-terms-banner>
            </div>
            <div class="col-span-12 md:col-span-8 lg:col-span-8 grid items-stretch">
                <home-call-to-action></home-call-to-action>
            </div>
            <div class="col-span-12 md:col-span-4 lg:col-span-4">
                <vx-box color="white"
                    class="col-span-1 h-full overflow-clip">
                    <h2 class="px-6 pt-6 pb-3 mb-0 font-extrabold text-slate-8000 text-base">
                        Getting Started
                    </h2>
                    <vx-list>
                        <vx-list-item v-if="['admin', 'owner', 'marketer'].includes(roleOnCurrentGroup)" href="/contacts/segments/new">
                            <vx-list-icon class="bg-slate-100">
                                <font-awesome-icon widthAuto :icon="faScreenUsers" />
                            </vx-list-icon>
                            Create a Segment
                        </vx-list-item>
                        <vx-list-item v-if="!currentOrgUnit" href="/messaging/snippets">
                            <vx-list-icon class="bg-slate-100">
                                <font-awesome-icon widthAuto :icon="faPlus" />
                            </vx-list-icon>
                            Create a Snippet
                        </vx-list-item>
                        <vx-list-item v-if="canUseMessageHub" href="/message-hub">
                            <vx-list-icon class="bg-slate-100">
                                <font-awesome-icon widthAuto :icon="faMessage" />
                            </vx-list-icon>
                            Send a Message
                        </vx-list-item>

                        <vx-list-item href="https://explore.voxie.com/voxiesupport"
                            target="_blank"
                            rel="noopener noreferrer">
                            <vx-list-icon class="bg-slate-200">
                                <font-awesome-icon widthAuto :icon="faStar" />
                            </vx-list-icon>
                            Browse our Documentation
                        </vx-list-item>
                    </vx-list>
                </vx-box>
            </div>

            <div class="col-span-12 flex flex-col gap-2 md:gap-6 lg:grid lg:grid-cols-2">
                <vx-box v-if="!currentOrgUnit" color="info"
                    class="px-6 pt-6 pb-3 flex flex-col gap-6">
                    <div>
                        <h2 class="font-extrabold text-slate-8000 text-base">
                            Browse Snippets
                        </h2>
                        <div class="text-slate-500 text-sm">
                            See messages shared by corporate or create your own for quick, consistent sending.
                        </div>
                    </div>
                    <img class="rounded-xl w-full block object-cover object-center aspect-536/196"
                        :src="homeGroupSnippetsUrl"
                        alt="Browse Snippets">
                    <vx-button href="/messaging/snippets"
                        block
                        size="lg">
                        Snippets <font-awesome-icon widthAuto :icon="faSquareArrowUpRight"></font-awesome-icon>
                    </vx-button>
                </vx-box>
                <vx-box v-if="['admin', 'marketer', 'blast'].includes(roleOnCurrentOrgUnit) || ['admin', 'owner', 'marketer', 'blast'].includes(roleOnCurrentGroup)" color="info"
                    class="px-6 pt-6 pb-3 flex flex-col gap-6">
                    <div>
                        <h2 class="font-extrabold text-slate-8000 text-base">
                            Send a Campaign
                        </h2>
                        <div class="text-slate-500 text-sm">
                            The fastest way to send a single message to multiple people.
                        </div>
                    </div>
                    <img class="rounded-xl mt-auto w-full block object-cover object-center aspect-536/196"
                        :src="homeGroupQuickBlastUrl"
                        alt="Send a Campaign">
                    <vx-button href="/messaging/quick-blast"
                        block
                        size="lg">
                        Quick Blast <font-awesome-icon widthAuto :icon="faSquareArrowUpRight"></font-awesome-icon>
                    </vx-button>
                </vx-box>
            </div>
        </div>
    </div>
</template>

<script setup>
import homeGroupQuickBlastUrl from '@img/home-group-quick-blast.jpg';
import homeGroupSnippetsUrl from '@img/home-group-snippets.jpg';
import HomeCallToAction from './HomeCallToAction.vue';
import HomeGroupTermsBanner from './HomeGroupTermsBanner.vue';
import {
    faMessage,
    faPlus,
    faScreenUsers,
    faSquareArrowUpRight,
    faStar,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxBox,
    VxButton,
    VxList,
    VxListIcon,
    VxListItem,
} from '@voxie/frontend-components';
import { useCurrentGroup } from '~/composables/useCurrentGroup';

const { currentOrgUnit, roleOnCurrentOrgUnit, roleOnCurrentGroup, canUseMessageHub } = useCurrentGroup();
</script>
